<template>
  <v-layout class="drivers-design" fill-height column >
    <!-- <v-checkbox
      v-model="driverQuestion.enabled"
      v-validate="'required'"
      :label="driverStatusLabel"
      data-vv-name="checkbox"
      type="checkbox"
      required
    ></v-checkbox> -->
    <v-layout align-center  class="driver-status mb-5">
      <span class="design-label">
          Logic: 
      </span>
      <!-- <v-radio-group v-model="driverQuestion.enabled" :mandatory="false" row>
        <v-radio label="All" value="ALL"></v-radio>
        <v-radio label="None" value="NONE"></v-radio>
        <v-radio label="Unhappy Customers" value="UNHAPPY"></v-radio>
      </v-radio-group> -->
      <v-select
          class="lg-select"
          :items="driverStatuses"
          item-text="label"
          item-value="id"
          solo
          v-model="driverQuestion.enabled"
          style="height: 40px; max-width: 265px;"
        ></v-select>
    </v-layout>
    
    <v-layout class="driver-details" :class="{'disabled': driverQuestion.enabled === 'NONE'}" column align-center>
      
      <div class="driver-question">
        <span class="design-label">
          Question: 
        </span>
        <input
          class="lgrm-box-input"
          :class="{ invalid: driverQuestion.question.length === 0 }"
          v-model="driverQuestion.question"
          placeholder="Type your question here..."
          :disabled="!driverQuestion.enabled"
        />
        <div
          class="error--text"
          v-if="driverQuestion.enabled && driverQuestion.question.length === 0"
        >
          Please enter a value or disable driver question
        </div>
      </div>
      
      <SlickList
        class="driver-inputs"
        lockAxis="y"
        v-model="driverQuestion.options"
        :useDragHandle="true"
        :lockToContainerEdges="true"
        :pressDelay="100"
      >
        <SlickItem
          class="driver-input"
          v-for="(driver, index) in driverQuestion.options.filter(
            d => d.deleted === false
          )"
          :index="index"
          :key="driver.id"
          :disabled="!driverQuestion.enabled"
        >
          <template v-if="!driver.deleted">
            <v-icon v-handle class="drag-handle" color="#A1A9C3"
              >reorder</v-icon
            >
            <input
              class="lgrm-box-input"
              :class="{ invalid: driver.label.length === 0 }"
              type="text"
              required
              :disabled="!driverQuestion.enabled"
              v-model="driver.label"
              placeholder="Your option"
              @keypress.enter="inputEnterKeypress($event, index)"
              ref="driverInputs"
              @change="change()"
            />
            <v-btn
              outline
              small
              fab
              @click="removeDriver(driver)"
              :disabled="!driverQuestion.enabled"
            >
              <v-icon>remove</v-icon>
            </v-btn>
            <v-btn
              v-if="
                index ===
                  driverQuestion.options.filter(d => d.deleted === false)
                    .length -
                    1
              "
              outline
              small
              fab
              class="add-button"
              :disabled="!driverQuestion.enabled"
              @click="addDriver"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
        </SlickItem>
      </SlickList>
    </v-layout>
    <v-snackbar v-model="snackbar" :bottom="'bottom'" :timeout="3000">
      {{ snackbarMsg }}
      <v-btn color="pink" flat @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import each from 'lodash/each'
import cloneDeep from 'lodash/cloneDeep'
import maxBy from 'lodash/maxBy'
import findIndex from 'lodash/findIndex'
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort'
import constants from '@/constants'

export default {
  name: 'DriversDesign',
  components: {
    SlickItem,
    SlickList
  },
  directives: { handle: HandleDirective },
  props: {
    driverStatusLabel: { type: String, default: 'Enable driver question' },
    question: {
      type: Object,
      default: function() {
        return {
          id: null,
          enabled: true,
          question: 'Please tell us what could be improved?',
          options: [
            { id: 1, label: 'Option 1', order_no: 1 },
            { id: 2, label: 'Option 2', order_no: 2 },
            { id: 3, label: 'Option 3', order_no: 3 }
          ],
          showFor: 'All'
        }
      }
    }
  },
  data: function() {
    return {
      driverQuestion: this.question,
      snackbar: false,
      snackbarMsg: '',
      driverStatuses: constants.questionLogicItems
    }
  },
  watch: {
    'driverQuestion.enabled': function() {
      this.$emit('change', this.getData())
    },
    'driverQuestion.question': function() {
      this.change()
    },
    'driverQuestion.options': {
      handler: function() {
        this.change()
      },
      deep: true
    }
  },
  methods: {
    addDriver: function() {
      this.snackbar = false
      if (
        this.driverQuestion.options.filter(d => d.deleted === false).length ===
        8
      ) {
        this.snackbarMsg = 'You can not add more than 8 options'
        this.snackbar = true
        return
      }
      const id = maxBy(this.driverQuestion.options, d => d.id).id + 1
      this.driverQuestion.options.push({
        id: id,
        label: '',
        order_no: id,
        deleted: false
      })
      const vm = this
      this.$nextTick(function() {
        vm.$refs.driverInputs[vm.$refs.driverInputs.length - 1].focus()
      })
    },
    inputEnterKeypress: function(ev, index) {
      console.log(ev, index)
      if (
        this.driverQuestion.options
          .filter(d => d.deleted === false)
          [index].label.trim() === ''
      ) {
        return
      } else if (
        this.driverQuestion.options.filter(d => d.deleted === false).length -
          1 ===
        index
      ) {
        this.addDriver()
      } else {
      }
    },
    removeDriver(driver) {
      if (
        this.driverQuestion.options.filter(d => d.deleted === false).length > 2
      ) {
        const index = findIndex(
          this.driverQuestion.options,
          d => d.id === driver.id
        )
        const c = this.driverQuestion.options[index]
        if (c.label.length === 0) {
          this.driverQuestion.options.splice(index, 1)
        } else {
          c.deleted = true
          this.driverQuestion.options.splice(index, 1, c)
        }
        this.$emit('change', this.getData())
      } else {
        this.snackbarMsg = 'You need at least 2 options'
        this.snackbar = true
      }
    },
    change() {
      let valid = true
      if (this.driverQuestion.question.length === 0) {
        valid = false
      }
      each(this.driverQuestion.options, function(option) {
        if (option.label.length === 0) {
          valid = false
        }
      })
      if (valid) {
        this.$emit('change', this.getData())
      }
    },
    getData() {
      const data = cloneDeep(this.driverQuestion)
      data.options = data.options.filter(function(d) {
        return d.label.length > 0
      })
      each(data.options, function(d, i) {
        d.order_no = i
      })
      return data
    }
  },
  computed: {}
}
</script>

<style lang="stylus">
.drivers-design {
    text-align center
    .lgrm-box-input {
        max-width 100%
    }
    .v-container {
        padding 0
    }
    .v-input--checkbox {
        .v-label {
            color: $color-primary-light-1
        }
    }

    .driver-status-label {
      padding-right: 15px
    }
    .driver-status {
      margin-bottom : 20px
      .v-label {
        color: $color-primary
      }
    }
}
.driver-details {
    text-align center
    position: relative
    &.disabled {
      opacity: .3
      
      .disabled-icon {
        display: block
      }
    }
    
    .driver-question {
        input {
            min-width 320px
            @media (max-width 400px)
            {
                width 150px
            }
        }
        margin-bottom 30px
    }
    .driver-inputs {
        display inline-block
        position relative
    }
    .disabled-icon {
      position: absolute
      height 100%
      top: 0px;
      left: 0;
      right: 0;
      margin: 0 auto;
      display: none
    }
}

.driver-input {
    position relative
    display flex

    input {
        padding-left 46px
        @media (max-width 400px)
        {
            width 150px
        }
    }

    .drag-handle {
        position: absolute;
        top: 14px;
        left: 15px;
    }

    .v-btn--floating {
        color: $color-primary
        border-color $color-primary-light-8
        position absolute
        right -60px

        &.add-button {
            right -110px
        }
    }
}
</style>
